<template>
  <div class="gkcon-speakers">
    <slot name="speakerHeader">
      <header class="con-speakers-header display-pc">
        <com-h1 title="一线国内外技术专家"></com-h1>
        <h4 v-if="this.$store.state.info.speakerConfirmPercent!==100">嘉宾邀请进行中（{{speakerLength}} 位嘉宾已确认）</h4>
        <h4 v-else>讲师邀约完毕</h4>
        <h5>
          <span class="no-confirm" :style="{width: confirmPercent}"></span>
        </h5>
      </header>
    </slot>

    <slot name="speakerTab">
      <section class="con-speakers-tab display-pc" v-if="speakersArr.length" slot="speakerTab">
        <ul>
          <li></li>
          <li class="scroll" :class="{active: curTab==0}" @click="curTab=0"><a>全部</a></li>
          <li
          v-for="(data, idx) of $store.state.speakerConfig"
          :key="idx"
            v-if="hasSpeaker(speakersArr, data.id)"
            class="scroll"
            :class="{active: curTab===data.id}"
            @click="curTab=data.id">{{data.name}}</li>
          <li></li>
        </ul>
      </section>
    </slot>

    <section
    v-for="(data, idx) of $store.state.speakerConfig"
    :key="idx"
    v-if="hasSpeaker(speakersArr, data.id) && curTab === 0 || curTab === data.id"
    class="con-speakers-list">

      <slot name="title" :title="data">
        <com-h1 class="small" :title="data.name"></com-h1>
      </slot>

      <div class="container">
        <com-speakers :speakers="filterSpeakers(speakersArr, data.id)">
        </com-speakers>
      </div>
    </section>
  </div>
</template>

<script>
/**
 * 讲师块底部不留 border
 * <speaker class="no-border"/>
 */

import ComSpeakers from '../com-speakers'
import ComH1 from '../com-h1'

export default {
  components: {
    ComSpeakers,
    ComH1
  },
  data () {
    return {
      curTab: 0
    }
  },
  computed: {
    speakers () {
      return this.$store.state.speakers
    },
    speakersArr () {
      return this.$store.state.speakersArr.filter(item => item.is_previous !== true)
    },
    speakerLength () {
      return this.speakersArr.length
    },
    confirmPercent () {
      return `${100 - this.$store.state.info.speakerConfirmPercent}%`
    }
  },
  beforeDestroy () {
  },
  methods: {
    filterSpeakers (speakers = [], typeId) {
      // var filteredSpeakers = []
      // for (let id in speakers) {
      //   if (speakers[id].typeId === typeId) filteredSpeakers.push(speakers[id])
      // }
      // return filteredSpeakers
      return speakers.filter(s => s.typeId === typeId)
    },
    hasSpeaker (speakers = [], typeId) {
      return speakers.some(speaker => {
        return speaker.typeId === typeId
      })
    }
  }
}
</script>

<style lang="sass" scoped>

// #f5f7f8

.con-speakers-header
  background-color: #F5F7F8
  text-align: center
  padding: 75px 0
  h4
    color: $grey
    font-size: 15px
    margin-top: 50px
    margin-bottom: 20px
  h5
    width: 720px
    margin: 0 auto
    display: block
    border-radius: 26px
    height: 26px
    position: relative
    overflow: hidden
    background-color: rgba(var(--primary-rgb-color), 0.7)
    background: linear-gradient(to right, var(--primary-color), rgba(var(--primary-rgb-color), 0.7))
  .no-confirm
    background-color: $grey-lighter
    height: 26px
    position: absolute
    right: 0
    top: 0

.con-speakers-tab
  > ul
    margin: 0 auto
    width: 100%
    background-color: #fff
    display: flex
  > ul > li
    width: 205px
    height: 75px
    line-height: 75px
    text-align: center
    font-size: 15px
    margin-right: 0
    background-color: #f5f7f8
    border-left: 1px solid $grey-lighter
    border-top: 1px solid $grey-lighter
    border-bottom: 1px solid $grey-lighter
    cursor: pointer
    &:first-child, &:last-child
      flex: 1
      background-color: #F5F7F8
      border-top: 1px solid #F5F7F8
    &.active
      background-color: #FFFFFF
      border-bottom: 1px solid #FFFFFF
      h5, h6
        color: var(--primary-color)
      h5
        font-size: 16px
        color: #595757
        margin-top: 18px
      h6
        font-size: 12px
        color: #898989
        margin-top: 6px
    a
      color: black

.con-speakers-list
  padding: 35px 0 50px 0
  border-bottom: 1px solid $grey-lighter
  &:last-child
    margin-bottom: 20px
    border-bottom: none

.gkcon-speakers
  &.no-border
    .con-speakers-list
      border-bottom: none
  &.offset
    padding-top: $nav-height-pc
    margin-top: -$nav-height-pc

</style>
